<template>
	<div>
		<div class="data-search">
			<el-row>
				<el-col :span="8">
					<el-input
					 placeholder="菜品名称"
					 v-model="query.key"
					 clearable
					></el-input>
				</el-col>
				<el-col :span="2">
					<el-button
					 type="primary"
					 icon="el-icon-search"
					 @click="search"
					>搜索</el-button>
				</el-col>
				<el-col :span="4" style="margin-top: 5px;">
					 
				</el-col>
				<el-col :span="4">
					<div class="grid-content"></div>
				</el-col>
				<el-col
				 :span="6"
				 style="text-align:right"
				>
				<span style="cursor:pointer" @click="changeDataMode(false)">
					<svg-icon
					 icon-class="datalist"
					 :style="listMode?{}:iconStyle"
					 style="width:2em;height:2em;"
					></svg-icon>
				</span>
				<span style="cursor:pointer" @click="changeDataMode(true)">
					<svg-icon
					icon-class="piclist"
					:style="picMode?{}:iconStyle"
					style="width:2em;height:2em;"
					></svg-icon>
				</span>
				<span style="cursor:pointer" @click="handleAdd">
					<svg-icon
					 style="color:#27B1A2;width:2em;height:2em;"
					 icon-class="add"
					></svg-icon>
				</span>
				</el-col>
			</el-row>
		</div>
		<div style="background:#F5F5F5;height:10px;width:100%"></div>
		<div
		 role="tablist"
		 aria-multiselectable="true"
		 class="el-collapse"
		 style="padding-right: 15px;"
		>
			<div class="el-collapse-item">
				<div
				 role="tabpanel"
				 class="el-collapse-item__wrap"
				>
					<el-collapse-transition>
						<div
						 class="el-collapse-item__content"
						 v-if="isShow"
						>
							<div class="search-condition">筛选：		
								<el-tag
										v-for="(item,index) in tags"
										:key="index"
										closable
										type="danger"
										color="rgb(255, 122, 0)"
										effect="dark"
										@close="handleClose(item)">
										{{ item.name }}
									</el-tag>
							</div>
							<div class="search-condition">类别：
								<a class="el-link--default" @click="filterTags('dishesCates')"><span class="el-link--inner">不限</span></a>
								<a class="el-link--default" @click="filterTags('dishesCates',item)" v-for="(item, index) in dishesCates" :key="index">
									<span class="el-link--inner">{{item.cateName}}</span>
								</a>
							</div>
							<div class="search-condition">技法：
								<a class="el-link--default" @click="filterTags('techniques')"><span class="el-link--inner">不限</span></a>
								<a class="el-link--default" @click="filterTags('techniques',item)" v-for="(item, index) in techniques" :key="index">
									<span class="el-link--inner">{{item.name}}</span>
								</a>
							</div>
							<div class="search-condition">荤素：
								<a class="el-link--default" @click="filterTags('meatVegetables')" style="font-size: 12px;"><span class="el-link--inner">不限</span></a>
								<a class="el-link--default" @click="filterTags('meatVegetables',item)" v-for="(item, index) in meatVegetables" :key="index">
									<span class="el-link--inner">{{item.label}}</span>
								</a>
								<span style="display:inline-block;margin-left:20px">清真：</span>
								<a class="el-link--default" @click="filterTags('halalFlag')" style="font-size: 12px;"><span class="el-link--inner">不限</span></a>
								<a class="el-link--default" @click="filterTags('halalFlag',item)" v-for="(item, index) in halalFlag" :key="item.lable">
									<span class="el-link--inner">{{item.label}}</span>
								</a>
								<span style="display:inline-block;margin-left:20px">色泽特征：</span>
								<a class="el-link--default" @click="filterTags('cishesColor')" style="font-size: 12px;"><span class="el-link--inner">不限</span></a>
								<a class="el-link--default" @click="filterTags('cishesColor',item)" v-for="(item, index) in cishesColor" :key="item.name">
									<span class="el-link--inner">{{item.name}}</span>
								</a>
							</div>
							<div class="search-condition">人群：
								<a class="el-link--default" @click="filterTags('crowd')" style="font-size: 12px;"><span class="el-link--inner">不限</span></a>
								<a class="el-link--default" @click="filterTags('crowd',item)" v-for="(item, index) in crowd" :key="index">
									<span class="el-link--inner">{{item.name}}</span>
								</a>
							</div>
							<div class="search-condition">季节：
								<a class="el-link--default" @click="filterTags('seasons')" style="font-size: 12px;"><span class="el-link--inner">不限</span></a>
								<a class="el-link--default" @click="filterTags('seasons',item)" v-for="(item, index) in seasons" :key="index">
									<span class="el-link--inner">{{item.name}}</span>
								</a>
							</div>
							<div class="search-condition">频次：
									<a class="el-link--default" @click="filterTags('frequency')" style="font-size: 12px;"><span class="el-link--inner">不限</span></a>
									<a class="el-link--default" @click="filterTags('frequency',item)" v-for="(item, index) in frequency" :key="index">
										<span class="el-link--inner">{{item.name}}</span>
									</a>
							</div>
							<div class="search-condition">
								<div style="float:left;width:38px">地域：</div>
								<div style="float:left;width:95%">
									<a class="el-link--default" @click="filterTags('area')" style="font-size: 12px;"><span class="el-link--inner">不限</span></a>
									<a class="el-link--default" @click="filterTags('area',item)" v-for="(item, index) in areaList" :key="index">
										<span class="el-link--inner">{{item.cityName}}</span>
									</a>
								</div>
							</div>
							<div class="search-condition">
								<div style="float:left;width:38px">功效：</div>
								<div style="float:left;width:95%">
									<a class="el-link--default" @click="filterTags('efficacy')" style="font-size: 12px;"><span class="el-link--inner">不限</span></a>
									<a class="el-link--default" @click="filterTags('efficacy',item)" v-for="(item, index) in efficacy" :key="index">
										<span class="el-link--inner">{{item.name}}</span>
									</a>
								</div>
							</div>
						</div>
					</el-collapse-transition>
				</div>
				<div
				 role="tab"
				 aria-expanded="true"
				>
					<div
					 role="button"
					 tabindex="0"
					 class="el-collapse-item__header"
					 @click="isShow = !isShow"
					>{{isShow?'收起高级筛选':'展开高级筛选'}}<i
						 class="el-collapse-item__arrow"
						 :class="[isShow? 'el-icon-arrow-up' : 'el-icon-arrow-down']"
						></i></div>
				</div>
			</div>
		</div>
		<div style="background:#F5F5F5;height:10px;width:100%"></div>
	</div>
</template>

<script>
import { fetchDictListByType } from '@/api/dict'
import { fetchDishesCateList } from '@/api/aicenter'
import { fetchAreaList } from '@/api/city'
export default {
	name: "DishesSearch",
	props: {
	},
  data() {
    return {
			isShow: false,
			listMode: false,
			picMode: true,
			mode: true,
			query: {
				key: null,
				bigCateIds: [],
				areaIds: [],
				techniqueDictValues: [],
				efficacyDictValues: [],
				mealsGroupDictValues: [],
				crowdDictValues: [],
				halalFlag: null,
				meatVegetables: null,
				colorDictValues: [],
				seasonDictValues:[]
			},
			tags: [],
			iconStyle: {
				"color": "#dbdbdb"
			},
			dishesCates:[],// 类别
			techniques:[], //技法
			efficacy: [], //功效
			seasons:[], //季节
			frequency:[], //频次
			areaList: [], //地域
			crowd: [], //人群
			meatVegetables: [
				{value: '0', label: '素菜'},
				{value: '1', label: '荤菜'},
			], //荤素
			halalFlag: [
				{value: '1', label: '清真'},
				{value: '0', label: '非清真'}
			],
			cishesColor:[]
    };
	},
	created() {
		this.query = this.$store.getters.searchParams;
		this.loadDishesCates();
		this.loadTechniques();
		this.loadCrowd();
		this.loadEfficacy();
		this.loadSeasons();
		this.fetchAreaList();
		this.loadFrequency();
		this.loadCishesColor();
		this.flagMeat();
		this.search();
	},
  methods: {
		filterTags(tagName,item) {
			if(tagName=='dishesCates') {
				if(item) {
					if(this.query.bigCateIds.indexOf(item.id) > -1) {
					return;
				}
					let tag = { id:item.id ,name : item.cateName, type: tagName}
					this.tags.push(tag)
					this.query.bigCateIds.push(item.id);
				} else {					
					this.tags = this.tags.filter(ta => ta.type!=tagName);
					this.query.bigCateIds = [];
				}
				this.search();
			} else if(tagName=='area') {
				if(item) {
					if(this.query.areaIds.indexOf(item.id) > -1) {
					return;
				}
					let tag = { id:item.id ,name : item.cityName, type: tagName}
					this.tags.push(tag)
					this.query.areaIds.push(item.id);
				} else {					
					this.tags = this.tags.filter(ta => ta.type!=tagName);
					this.query.areaIds = [];
				}
				this.search();
			}   else if(tagName == 'seasons') {
				let values = this.filterDictTags(this.query.seasonDictValues,tagName,item);
				if(values!=undefined) {
					this.query.seasonDictValues = values;
					this.search();
				}
			}  else if(tagName == 'frequency') {
				let values = this.filterDictTags(this.query.mealsGroupDictValues,tagName,item);
				if(values!=undefined) {
					this.query.mealsGroupDictValues = values;
					this.search();
				}
			} else if(tagName == 'techniques') {
				let values = this.filterDictTags(this.query.techniqueDictValues,tagName,item);
				if(values!=undefined) {
					this.query.techniqueDictValues = values;
					this.search();
				}
			} else if(tagName == 'efficacy') {
				let values = this.filterDictTags(this.query.efficacyDictValues,tagName,item);
				if(values!=undefined) {
					this.query.efficacyDictValues = values;
					this.search();
				}
			} else if(tagName == 'crowd') {
				let values = this.filterDictTags(this.query.crowdDictValues,tagName,item);
				if(values!=undefined) {
					this.query.crowdDictValues = values;
					this.search();
				}
			} else if(tagName == 'halalFlag') {
				if(item) {
					if(item.value && this.query.halalFlag == item.value){
						return;
					}
					let tag = { id:item.value ,name : item.label, type: tagName}
					this.tags = this.tags.filter(ta => ta.type!=tagName);
					this.tags.push(tag)
					this.query.halalFlag = item.value;
				} else {
					this.query.halalFlag = null;
				}
				this.search();
			} else if(tagName == 'meatVegetables') {
				if(item) {
					if(item.value && this.query.meatVegetables == item.value){
						return;
					}
					let tag = { id:item.value ,name : item.label, type: tagName}
					this.tags = this.tags.filter(ta => ta.type!=tagName);
					this.tags.push(tag)
					this.query.meatVegetables = item.value;
				} else {
					this.query.meatVegetables = null;
				}
				this.search();
			} else if(tagName == 'cishesColor') {
				let values = this.filterDictTags(this.query.colorDictValues,tagName,item);
				if(values!=undefined) {
					this.query.colorDictValues = values;
					this.search();
				}
			}
		},
		filterDictTags(query,tagName,item) {
			if(item) {
				if(query.indexOf(item.value) > -1) {
					return;
				}
				let tag = { id: item.value, name: item.name, type: tagName };
				this.tags.push(tag);
				query.push(item.value);
			} else {
				this.tags = this.tags.filter(ta => ta.type!=tagName);
				query = [];
			}
			return query;
		},
		flagMeat() {
			if(this.query.meatVegetables) {
				this.meatVegetables.forEach(item=>{
					this.query.meatVegetables.forEach(te=>{
						if(item.value == te) {
							let tag = { id: item.value, name: item.label, type: 'meatVegetables' };
							this.tags.push(tag);
						}
					})
				})
			}
			if(this.query.halalFlag) {
				this.halalFlag.forEach(item=>{
					this.query.halalFlag.forEach(te=>{
						if(item.value == te) {
							let tag = { id: item.value, name: item.label, type: 'halalFlag' };
							this.tags.push(tag);
						}
					})
				})
			}
			if(this.query.crowdDictValues.length > 0 || this.query.bigCateIds.length > 0 || this.query.efficacyDictValues.length > 0 
				 || this.query.halalFlag || this.query.techniqueDictValues.length > 0 || this.query.meatVegetables
				 || this.query.colorDictValues.length > 0 || this.query.mealsGroupDictValues.length > 0
				 || this.query.seasonDictValues.length > 0 || this.query.areaIds.length > 0) {
					 this.isShow = true;
				 }
		},
		loadDishesCates() {
			fetchDishesCateList().then(response=>{
        this.dishesCates = response.data;
				if(this.query.bigCateIds) {
					this.dishesCates.forEach(item=>{
						this.query.bigCateIds.forEach(te=>{
							if(item.id == te) {
								let tag = { id: item.value, name: item.cateName, type: 'dishesCates' };
								this.tags.push(tag);
							}
						})
					})
				}
      })
		},
		loadTechniques() {
			fetchDictListByType("technique").then(response=>{
				this.techniques = response.data;
				if(this.query.techniqueDictValues) {
					this.techniques.forEach(item=>{
						this.query.techniqueDictValues.forEach(te=>{
							if(item.value == te) {
								let tag = { id: item.value, name: item.name, type: 'techniques' };
								this.tags.push(tag);
							}
						})
					})
				}
			})
		},
		loadCrowd() {
			fetchDictListByType("crowd").then(response=>{
				this.crowd = response.data;
				if(this.query.crowdDictValues) {
					this.crowd.forEach(item=>{
						this.query.crowdDictValues.forEach(te=>{
							if(item.value == te) {
								let tag = { id: item.value, name: item.name, type: 'crowd' };
								this.tags.push(tag);
							}
						})
					})
				}
			})
		},
		loadEfficacy() {
			fetchDictListByType("efficacy").then(response=>{
				this.efficacy = response.data;
				if(this.query.efficacyDictValues) {
					this.efficacy.forEach(item=>{
						this.query.efficacyDictValues.forEach(te=>{
							if(item.value == te) {
								let tag = { id: item.value, name: item.name, type: 'efficacy' };
								this.tags.push(tag);
							}
						})
					})
				}
			})
		},
		loadCishesColor() {
			fetchDictListByType("cishes_color").then(response=>{
				this.cishesColor = response.data;
				if(this.query.colorDictValues) {
					this.cishesColor.forEach(item=>{
						this.query.colorDictValues.forEach(te=>{
							if(item.value == te) {
								let tag = { id: item.value, name: item.name, type: 'cishesColor' };
								this.tags.push(tag);
							}
						})
					})
				}
			})
		},
		loadSeasons() {
			fetchDictListByType("season").then(response=>{
				this.seasons = response.data;
					if(this.query.seasonDictValues) {
						this.seasons.forEach(item=>{
							this.query.seasonDictValues.forEach(te=>{
								if(item.value == te) {
									let tag = { id: item.value, name: item.name, type: 'seasons' };
									this.tags.push(tag);
								}
							})
						})
					}
			})
		},
		loadFrequency() {
			fetchDictListByType("season_number").then(response=>{
				this.frequency = response.data;
					if(this.query.mealsGroupDictValues) {
						this.frequency.forEach(item=>{
							this.query.mealsGroupDictValues.forEach(te=>{
								if(item.value == te) {
									let tag = { id: item.value, name: item.name, type: 'frequency' };
									this.tags.push(tag);
								}
							})
						})
					}
			})
		},
		fetchAreaList() {
			fetchAreaList().then(response=>{
				this.areaList = response.data;
				if(this.query.areaIds) {
					this.areaList.forEach(item=>{
						this.query.areaIds.forEach(te=>{
							if(item.id == te) {
								let tag = { id: item.id, name: item.cityName, type: 'area' };
								this.tags.push(tag);
							}
						})
					})
				}
			})
		},
    handleClose(tag) {
			this.tags.splice(this.tags.indexOf(tag), 1);
			if(tag.type == 'dishesCates') {
				this.query.bigCateIds.splice(this.query.bigCateIds.indexOf(tag.id), 1);
			}	else if(tag.type == 'area') {
				this.query.areaIds.splice(this.query.areaIds.indexOf(tag.id), 1);
			} else if(tag.type == 'techniques') {
				this.query.techniqueDictValues.splice(this.query.techniqueDictValues.indexOf(tag.id), 1);
			} else if(tag.type == 'efficacy') {
				this.query.efficacyDictValues.splice(this.query.efficacyDictValues.indexOf(tag.id), 1);
			} else if(tag.type == 'crowd') {
				this.query.crowdDictValues.splice(this.query.crowdDictValues.indexOf(tag.id), 1);
			} else if(tag.type == 'halalFlag') {
				this.query.halalFlag = null;
			} else if(tag.type == 'meatVegetables') {
				this.query.meatVegetables = null;
			} else if(tag.type == 'seasons') {
				this.query.seasonDictValues.splice(this.query.seasonDictValues.indexOf(tag.id), 1);
			}else if(tag.type == 'cishesColor') {
				this.query.colorDictValues.splice(this.query.colorDictValues.indexOf(tag.id), 1);
			} else if(tag.type == 'frequency') {
				this.query.mealsGroupDictValues.splice(this.query.mealsGroupDictValues.indexOf(tag.id), 1);
			}
			this.search();
		},
    handleAdd() {
			this.$emit('handleAdd');
		},
		changeDataMode(val) {
			this.mode = val;
			this.listMode = !val;
			this.picMode = val;
			this.$emit('changeDataMode',val)
		},
		search() {
			this.$store.dispatch('setSearchParams',this.query);
			this.$emit('search',this.query);
		}
  }
};
</script>

<style>
.unset {
	color: #cccccc;
	cursor:unset
}
</style>



// WEBPACK FOOTER //
// src/views/datacenter/components/basedata/dishes/dishes_search.vue